import DEBUG from "../DEBUG";
import type {LogoPoolController} from "../controllerModules/logoPoolController";
import type {LokalisierungsProvider} from "../../global/Localizer";
import {CONSTANTS} from "../meta_data";
import globalsObject, {handleError} from "../globalsObject";
import {LogoTargetAfterChoosing, RahmentabsLogoReiter} from "./rahmenTabsLogoReiter";
import type {FileUploadResponse} from "../interfaceDataClasses";
import {FileUploadValidation} from "../fileUploadValidation";
import axios from "axios";

export class LogoFileUpload {
    private logoPoolController: LogoPoolController;
    private localizer: LokalisierungsProvider;
    private static progressbar = document.getElementsByClassName("progressbar-wrapper")[0] as HTMLElement|undefined;

    public constructor(logoPoolController:LogoPoolController, localizer:LokalisierungsProvider) {
        this.localizer = localizer;

        this.logoPoolController = logoPoolController;
        globalsObject.resourceManager.createTask("initLogoUpload")
            .discardAfterExecution()
            .when("dataModel", "user toBeNotEmpty")
            .thenDo(()=>this.initFileUploader());

    }
    private releaseBlock = ()=>LogoFileUpload.progressbar.style.display = "none";//this.sendblockEvent("Release");
    private requestBlock = ()=>LogoFileUpload.progressbar.style.removeProperty("display");//this.sendblockEvent("Request");


    private getFileUpload_onErrorHandler() {
        const $this = this;
        return function (files, status:string, message:string) {
            $this.releaseBlock();
            if (DEBUG) {
                console.log(status + "; " + message);
            }

            if (status === "parsererror") {
                globalsObject.errorHandler.handleErrorTranslateMessage(
                    "ajaxFail",
                    "fileUpload",
                    "konf_FileMaybeToBig",
                );
            }
            else {
                handleError("ajaxFail", "fileUpload", $this.localizer.translate("konf_uploadErrorTitle", "Datei Upload fehlgeschlagen"));
            }
        };
    }

    initFileUploader () {
        /*LogoFileUpload.initElementAsFileUpload(
            document.getElementById("logoUpload") as HTMLInputElement,
            this.getLogoUploadSuccessHandler(LogoTargetAfterChoosing.LIBRARY),
            this.getFileUpload_onErrorHandler()
        );*/

        LogoFileUpload.initElementAsFileUpload(
            document.getElementById("newLogoInput") as HTMLInputElement,
            this.getLogoUploadSuccessHandler(LogoTargetAfterChoosing.DRAFT),
            this.getFileUpload_onErrorHandler()
        );
    }

    private getLogoUploadSuccessHandler(logoTargetAfterChoosing:LogoTargetAfterChoosing) {
        return (response:FileUploadResponse)=>{
            RahmentabsLogoReiter.logoTargetAfterChoosing = logoTargetAfterChoosing
            if(logoTargetAfterChoosing === LogoTargetAfterChoosing.DRAFT) {
                RahmentabsLogoReiter.hideOverlays();
            }
            this.logoPoolController.logoUploaded(response);

            this.releaseBlock();
        }
    }

    static initElementAsFileUpload(element:HTMLInputElement, onSuccess, onError) {
        function changeHandler(event){
            debugger;
            if(FileUploadValidation.validateFileExtension(CONSTANTS.UPLOAD_CONVERTABLEFORMATS, event.currentTarget.files[0])) {
                EventVerteiler.broadcast("unsupportedButConvertableLogoFormatInUploadEvent", event.currentTarget.files[0]);
                (document.getElementsByClassName(".ajax-file-upload-statusbar")[0] as HTMLElement).style.display = "none";
                return
            }

            if(!FileUploadValidation.validateFileExtension(CONSTANTS.UPLOAD_ALLOWED_FILETYPES_AS_ARRAY, event.currentTarget.files[0])) {
                onError({ name: "InvalidFileExtensionError", message: "That file format is not allowed" })
                return;
            }
            if(!FileUploadValidation.validateFileSize(CONSTANTS.UPLOAD_MAXFILESIZE, event.currentTarget.files[0])) {
                onError({ name: "MaxFileSizeError", message: "That file is too big" });
                return;
            }
            if(!FileUploadValidation.validateFileMimeType(CONSTANTS.UPLOAD_ACCEPTFILES_AS_ARRAY, event.currentTarget.files[0])) {
                onError({ name: "InvalidFileTypeError", message: "That file format is not allowed" });
                return;
            }
            const formData = new FormData();
            formData.append("file", event.currentTarget.files[0]);

            axios.post("/konfigurator_php/cloud_storage/uploadFile.php",
                formData,
                {headers: {'Content-Type': 'multipart/form-data'}})
                .then(response => onSuccess(response.data));
            element.value = null;
        }


        element.removeEventListener("change", changeHandler);
        element.addEventListener("change", changeHandler)
    }
}
